var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"egg"},[_c('img',{staticClass:"egg__image",attrs:{"src":require(("@/assets/practices/expanded_form/" + _vm.eggColor + ".svg")),"alt":"egg"}}),_c('div',{staticClass:"egg__number"},[_vm._v(_vm._s(_vm.eggNumber))])])}
var staticRenderFns = []

export { render, staticRenderFns }